module.exports = __webpack_public_path__ + "static/media/2.18f195c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/2.png
// module id = 1261
// module chunks = 0